export default __webpack_public_path__ + "static/media/img-0039.17fd8102.png";